import { logger } from '@/lib/telemetry/logger';

/** Reserve the popup synchronously inside the user's click, before authorization. */
export function reserveExchangeBrowser(): {
  open(url: string): boolean;
  close(): void;
  closed(): boolean;
} | null {
  const popup = window.open('about:blank', '_blank', 'popup,width=520,height=720');
  if (!popup) {
    logger.warn('onramp.exchange_browser_failed', { stage: 'open', code: 'blocked' });
    return null;
  }
  popup.opener = null;
  return {
    open(url: string): boolean {
      try {
        const destination = new URL(url);
        if (
          destination.protocol !== 'https:' ||
          !['login.coinbase.com', 'www.coinbase.com'].includes(destination.hostname) ||
          destination.port ||
          destination.username ||
          destination.password ||
          popup.closed
        ) {
          popup.close();
          logger.warn('onramp.exchange_browser_failed', { stage: 'navigate', code: 'unavailable' });
          return false;
        }
        popup.location.replace(destination.href);
        return true;
      } catch {
        logger.warn('onramp.exchange_browser_failed', { stage: 'navigate', code: 'unavailable' });
        popup.close();
        return false;
      }
    },
    close: (): void => popup.close(),
    closed: (): boolean => popup.closed,
  };
}
